import { KeycardDoor } from "../../data/models.interface"
import useQuery from "../useQuery"
import useSessionStorage from "../useSessionStorage"
import useSort, { SortDirection } from "../useSort"

export interface KeycardDoorsQuery {
	data: KeycardDoorsOutput | undefined
	loading: boolean
	error: string | undefined
	entityFilter: string
	setEntityFilter: (value: string) => void
	keycardFilter: string
	setKeycardFilter: (value: string) => void
	doorFitler: string
	setDoorFilter: (value: string) => void
	sortBy: (property: string, direction?: SortDirection) => void
}
export const useGetKeycardDoorsQuery = (page: string): KeycardDoorsQuery => {
	const [entityFilter, setEntityFilter] = useSessionStorage(page + "-entity", "")
	const [keycardFilter, setKeycardFilter] = useSessionStorage(page + "-keycard", "")
	const [doorFitler, setDoorFilter] = useSessionStorage(page + "-door", "")
	const { sortProperty, sortDirection, sortBy } = useSort("keycard")
	//
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/keycard-doors`
	let filterUrl = ""
	if (entityFilter) filterUrl += `&entity=${entityFilter}`
	if (keycardFilter) filterUrl += `&keycard=${keycardFilter}`
	if (doorFitler) filterUrl += `&door=${doorFitler}`
	if (entityFilter?.length >= 3 || keycardFilter?.length >= 3 || doorFitler?.length >= 3) filterUrl += `&limit=1000`
	filterUrl += `&sort=${sortProperty}`
	filterUrl += `&sort-direction=${sortDirection}`
	filterUrl = filterUrl.replace("&", "?")
	const query = useQuery<void, KeycardDoorsOutput>(url + filterUrl)
	return { ...query, entityFilter, setEntityFilter, keycardFilter, setKeycardFilter, doorFitler, setDoorFilter, sortBy }
}
interface KeycardDoorsOutput {
	keycardDoors: KeycardDoor[]
}
